import { Plus, Server } from "lucide-react";

export const ServerCreatePanel = ({ newServer, onChange, onCreate }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-900/65 p-5" data-testid="create-server-panel">
    <div className="mb-4 flex items-start gap-3">
      <div className="rounded-md border border-emerald-500/30 bg-emerald-500/10 p-2 text-emerald-300"><Server className="h-5 w-5" /></div>
      <div>
        <h2 className="text-base font-semibold text-white">Register redirect server</h2>
        <p className="mt-0.5 text-xs text-slate-500">Create the dashboard record before running the deployment wizard.</p>
      </div>
    </div>
    <div className="grid gap-3 xl:grid-cols-[1fr_1fr_1.2fr_auto] xl:items-end">
      <label className="block">
        <span className="mb-1.5 block text-xs font-medium uppercase text-slate-500">Server name</span>
        <input type="text" placeholder="e.g., RDR5" value={newServer.name} onChange={(event) => onChange({ ...newServer, name: event.target.value })} className="input-dark w-full" data-testid="new-server-name" />
      </label>
      <label className="block">
        <span className="mb-1.5 block text-xs font-medium uppercase text-slate-500">IPv4 address</span>
        <input type="text" placeholder="e.g., 192.168.1.1" value={newServer.ip_address} onChange={(event) => onChange({ ...newServer, ip_address: event.target.value })} className="input-dark w-full font-mono" data-testid="new-server-ip" />
      </label>
      <label className="block">
        <span className="mb-1.5 block text-xs font-medium uppercase text-slate-500">Description</span>
        <input type="text" placeholder="Region, provider, or purpose" value={newServer.description} onChange={(event) => onChange({ ...newServer, description: event.target.value })} className="input-dark w-full" data-testid="new-server-description" />
      </label>
      <button type="button" onClick={onCreate} disabled={!newServer.name || !newServer.ip_address} className="flex h-10 items-center justify-center gap-2 rounded-md bg-cyan-500 px-4 text-sm font-semibold text-slate-950 transition-colors hover:bg-cyan-400 disabled:cursor-not-allowed disabled:opacity-40" data-testid="create-server-btn">
        <Plus className="h-4 w-4" /> Create server
      </button>
    </div>
  </div>
);